import { Fragment } from 'react';
import { FormFieldError } from '../FormFieldError/FormFieldError';
import { PersonModalTickSVG } from '../../svgComponents/personModalTickSVG/PersonModalTickSVG';
import styles from './FormField.module.css';
import classNames from 'classnames';

const renderCheckboxInput = (props) => {
    const {
        input,
        label,
        disabled,
        type,
        placeholder,
        hideError,
        meta: { pristine, touched, error }
    } = props;

    const isActive = input.value === true ? 'is-active' : null;

    const checkboxStyles = classNames(
        styles.checkboxBackground,
        styles[isActive]
    );

    return (
        <div className={styles.checkbox}>
            {(!pristine || touched) && (
                <FormFieldError hide={hideError} message={error} />
            )}

            <label
                htmlFor={`checkboxInput-${input.name}`}
                className={styles.label}
            >
                <div className={checkboxStyles}>
                    <div className={styles.tick}>
                        <PersonModalTickSVG />
                    </div>
                </div>
                <input
                    {...input}
                    id={`checkboxInput-${input.name}`}
                    disabled={disabled}
                    type={type}
                    placeholder={placeholder}
                    className={styles.input}
                    data-testid={props['data-testid']}
                />
                <span className={styles.labelText}>{label}</span>
            </label>
        </div>
    );
};

export const renderTextInput = (props) => {
    const {
        input,
        placeholder,
        type,
        disabled,
        readOnly,
        label,
        hideError,
        meta: { touched, error }
    } = props;

    return (
        <>
            {label && (
                <label htmlFor={props.id} className={styles.label}>
                    {label}
                </label>
            )}
            {touched && <FormFieldError hide={hideError} message={error} />}
            <input
                {...input}
                id={props.id}
                className={styles.input}
                placeholder={placeholder}
                data-testid={props['data-testid']}
                type={type}
                disabled={disabled}
                readOnly={!!readOnly}
            />
        </>
    );
};

const renderTextArea = (props) => {
    const {
        input,
        placeholder,
        readOnly,
        label,
        hideError,
        meta: { touched, error },
        bottomLabel
    } = props;

    return (
        <>
            {label && <label className={styles.label}>{label}</label>}
            {touched && <FormFieldError hide={hideError} message={error} />}
            <textarea
                {...input}
                className={styles.textarea}
                placeholder={placeholder}
                data-testid={props['data-testid']}
                readOnly={!!readOnly}
            />
            {bottomLabel ? bottomLabel : null}
        </>
    );
};

export const renderField = (props) => {
    switch (props.type) {
        case 'textarea':
            return renderTextArea(props);
        case 'checkbox':
            return renderCheckboxInput(props);
        default:
            return renderTextInput(props);
    }
};
